import { IColorData } from './colors-menu/colors.data';
import { ViewWindowIndex } from '@viewer/data';

export const startConfigForSegmentation = {
  arrayType: 0,
  renderOutline: true,
  renderFill: true,
  shouldRenderInactiveLabelmaps: true,
  radius: 10,
  minRadius: 1,
  maxRadius: 50,
  segmentsPerLabelmap: 10000,
  fillAlpha: 0.2,
  fillAlphaInactive: 0.1,
  outlineAlpha: 0.7,
  outlineAlphaInactive: 0.35,
  outlineWidth: 3,
  storeHistory: true,
};

export const DEFAULT_SETTINGS = {
  mouseEnabled: true,
  touchEnabled: false, // TODO
  showSVGCursors: true,
  globalToolSyncEnabled: true,
  autoResizeViewports: true,
  lineDash: [4, 4],
};

export const DEFAULT_STYLE = {
  width: 1,
  color: '#02FAE5',
  activeColor: '#00FF00',
  fillColor: '#0000FF',
  fontFamily: 'Roboto',
  fontSize: 18,
  backgroundColor: 'rgba(1, 1, 1, 0.7)',
};

export interface ISlicePixelData {
  numberOfSlice: string;
  basedPixelData: any;
  pixelDataBeforeAcrivatedViewDiff: any;
}

export interface IViewVector {
  order: number[];
  signs: number[];
}

export interface IViewsVectors {
  axial: IViewVector;
  coronal: IViewVector;
  sagittal: IViewVector;
}

export interface IViewersObjectNumber {
  viewer1: number;
  viewer2: number;
  viewer3: number;
}

export interface IViewersObjectNumbersData {
  viewer1: number[];
  viewer2: number[];
  viewer3: number[];
}

export interface IViewersObjectBoolean {
  viewer1: boolean;
  viewer2: boolean;
  viewer3: boolean;
}

export interface IViewersObjectColorData {
  viewer1: IColorData[];
  viewer2: IColorData[];
  viewer3: IColorData[];
}

export interface OptionsForTool {
  invert?: boolean;
}

export enum TYPE_OF_CHANGE_RESULT {
  DECREASE = 'decrease',
  INCREASE = 'increase',
}

export enum CUSTOM_TOOLS_EVENTS {
  SHOW_DIFF_TOOL_CLOSE = 'showDiffToolClose',
}

export interface ISerieData {
  coronal?: string;
  currentImageIdIndex?: number;
  customLoader?: string;
  imageIds?: string[];
  instances?: any;
  nrrdHeader?: INnrdHeader;
  numberOfImages?: number;
  sagittal?: string;
  seriesDescription?: string;
  seriesUID?: string;
  orientation?: string;
}

export interface INnrdHeader {
  volume: INnrdHeaderVolume;
}

export interface INnrdHeaderVolume {
  acquisition_date: any;
  cols: number;
  imageIds: string[];
  imagePosition: number[];
  intercept: any;
  numberOfSlices: number;
  phase: undefined;
  pixelSpacing: number[];
  repr: string;
  rows: number;
  series_description: any;
  sliceThickness: number;
  slope: any;
  study_description: any;
}

export interface IUndoRedoEvent {
  viewerId: string;
  actions: IUndoRedoData[];
}

export interface IUndoRedoData {
  sliceIndex: number;
  pixelIndex: number;
  color: number;
}

export interface IReferenceLineItem {
  viewWindowIndex: ViewWindowIndex;
  canvasContext: any;
  image: any;
  viewerElements: {
    [key: string]: HTMLElement;
  };
}

export const BASE_COLOR_LUT = [
  [120, 94, 240, 51],
  [120, 94, 240, 51],
  [120, 94, 240, 51],
  [255, 176, 0, 51],
  [18, 206, 118, 51],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
];

export const BASE_COLOR_LUT_TIBIA = [
  [220, 38, 127, 51],
  [220, 38, 127, 51],
  [220, 38, 127, 51],
  [255, 176, 0, 51],
  [18, 206, 118, 51],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0],
  [0, 0, 0, 0]
];

export interface IInstanceData {}

export const MASK_FILE_NAME = 'mask.nrrd';

export const IMAGE_FILE_NAME = 'image.nrrd';

export enum SEGMENT_INDEX {
  FEMUR = 1,
  TIBIA_CT = 2,
  TIBIA_MRI = 3
};

export enum CASE_TYPE {
  FEMUR = 'femur',
  TIBIA = 'tibia'
}

export enum CASE_IMAGING {
  MRI = 'MRI',
  CT = 'CT'
}

export enum BONE_MODEL_ORIENTATION {
  FEMUR = 'Axial',
  TIBIA = 'TOP'
}
